export default {
    data: [{
        key: 'required',
        name: 'Required',
        types: ['all'],
    }, {
        key: 'unique',
        name: 'Unique',
        types: ['all'],
    }, {
        key: 'minValue',
        name: 'Min Value',
        types: ['int', 'decimal'],
    }, {
        key: 'maxValue',
        name: 'Max Value',
        types: ['int', 'decimal'],
    }, {
        key: 'minDate',
        name: 'Min Date',
        types: ['date'],
    }, {
        key: 'maxDate',
        name: 'Max Date',
        types: ['date'],
    }],
}
